export var ColorStyle = {
  pending: 'warning.main',
  warning: 'warning.main',
  success: 'success.main',
  informative: 'info.main',
  scheduled: 'info.main',
  processing: 'neutral.black',
  help: 'neutral.black',
  issues: 'neutral.black',
  cancel: 'critical.main',
  decline: 'critical.main',
  alert: 'critical.main'
};
//# sourceMappingURL=StatusIconSolid.theme.utils.js.map